import { BaseControl } from "../base-control";

class RadioControlCtrl extends BaseControl {
  selected = false;
  requiredValid = false;
  radioCircleClass = "";
  radioCircleStyle = {};
  choice;

  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
  
  async initializeControlData() {
    await super.initializeControlData();
    this.choice = this.token.options?.choice;
    this.setHiddenBorder();
    this.updateFlags();
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.updateFlags();
  }

  updateFlags() {
    this.selected = (this.model.value == this.choice.value);
    this.requiredValid = this.model?.value || !this.required;

    let className = this.selected ? 'fa-circle ' : 'fa-circle-o ';
    if (!this.isPrint && this.enabled) className += this.requiredValid ? 'ng-valid-required ' : 'ng-invalid-required ';
    this.radioCircleClass = className;
    this.radioCircleStyle = (this.hideBorder && !this.selected) ? { color: 'transparent' } : {};
  }
  
  radioKeyDown(keyEvent) {
    if ([13, 32].includes(keyEvent.which)) { // enter, spacebar
      keyEvent.preventDefault();
      this.selectRadio();
    }
  }

  selectRadio(){
    if (this.isNotAForm) {
      this.selected ? this.stdModel(this.presetValue) : this.stdModel(this.choice.value);
      return;
    }

    if (!this.enabled) return;

    if (this.model?.value && this.model?.value == this.choice.value) this.clearModel();
    else this.stdModel(this.choice.value);
  }

  setHiddenBorder() {
    if (this.isNotAForm) return;
    this.hideBorder = 
      (this.token.options?.hideBorder === undefined) ?
        (this.isDynamic ? false : true) : this.token.options.hideBorder;
  }

  updateBehaviorsStatus() {
    super.updateBehaviorsStatus();
    this.updateFlags();
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/radio-control/radio-control.component.html",
  controller: RadioControlCtrl
};